// Mock Data for BITSAT Test Analysis

export const testMockData = {
  _id: '671923ae6bc3007257f366ec',
  type: 'paid',
  percentile: {
    percentileData: {
      _id: '673c75ef2621a3331bdc7b55',
      title: 'BITSAT Full Test',
      description: 'This percentile calculation is done on the basis of BITSAT 2024 data',
      consolationText:
        'Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.',
      data: [
        {
          _id: '673c75ef2621a3331bdc7b56',
          percentile: 99.9,
          score: 370,
        },
        {
          _id: '673c75ef2621a3331bdc7b57',
          percentile: 99.8875,
          score: 367,
        },
        {
          _id: '673c75ef2621a3331bdc7b58',
          percentile: 99.875,
          score: 365,
        },
        {
          _id: '673c75ef2621a3331bdc7b59',
          percentile: 99.8625,
          score: 362,
        },
        {
          _id: '673c75ef2621a3331bdc7b5a',
          percentile: 99.85,
          score: 360,
        },
        {
          _id: '673c75ef2621a3331bdc7b5b',
          percentile: 99.8375,
          score: 358,
        },
        {
          _id: '673c75ef2621a3331bdc7b5c',
          percentile: 99.825,
          score: 355,
        },
        {
          _id: '673c75ef2621a3331bdc7b5d',
          percentile: 99.8125,
          score: 352,
        },
        {
          _id: '673c75ef2621a3331bdc7b5e',
          percentile: 99.8,
          score: 350,
        },
        {
          _id: '673c75ef2621a3331bdc7b5f',
          percentile: 99.78,
          score: 348,
        },
        {
          _id: '673c75ef2621a3331bdc7b60',
          percentile: 99.76,
          score: 345,
        },
        {
          _id: '673c75ef2621a3331bdc7b61',
          percentile: 99.74,
          score: 343,
        },
        {
          _id: '673c75ef2621a3331bdc7b62',
          percentile: 99.72,
          score: 340,
        },
        {
          _id: '673c75ef2621a3331bdc7b63',
          percentile: 99.7,
          score: 338,
        },
        {
          _id: '673c75ef2621a3331bdc7b64',
          percentile: 99.683333,
          score: 335,
        },
        {
          _id: '673c75ef2621a3331bdc7b65',
          percentile: 99.666667,
          score: 332,
        },
        {
          _id: '673c75ef2621a3331bdc7b66',
          percentile: 99.65,
          score: 330,
        },
        {
          _id: '673c75ef2621a3331bdc7b67',
          percentile: 99.633333,
          score: 328,
        },
        {
          _id: '673c75ef2621a3331bdc7b68',
          percentile: 99.616667,
          score: 325,
        },
        {
          _id: '673c75ef2621a3331bdc7b69',
          percentile: 99.6,
          score: 323,
        },
        // ... (continuing percentile data with scores up to ~120 for 90th percentile)
        {
          _id: '673c75ef2621a3331bdc7be1',
          percentile: 90,
          score: 245,
        },
      ],
      createdAt: '2024-11-19T16:56:39.111Z',
      updatedAt: '2024-11-19T16:56:39.111Z',
      __v: 0,
    },
    isAvailable: true,
    version: 1,
  },
  analysisVideo: '',
  detailAccessDate: '2024-07-01T03:30:00.000Z',
  analysisVideoCdn: 'vm',
  analysisAllowed: true,
  mode: 'normal',
  isStarted: true,
  isExpired: false,
  isAttempted: true,
  packTitle: 'BITSAT 2025 Full Test Series for Class 12 (July Batch)',
  userType: 'free',
  paymentLink:
    'https://pay.mathongo.com/?item_id=_Z5VOZ-Y2&coupon=CHAMPS25&utm_source=quizrr&utm_medium=packs_platform&utm_campaign=bitsat_2025_full_test_series_class_12_july',
  startDate: '2024-07-01T03:30:00.000Z',
  endDate: '2025-08-31T18:29:59.000Z',
  status: 'available',
  ctype: null,
  title: 'BITSAT Full Test',
  totalQuestions: 130,
  totalMarks: 390,
  bonusQuestions: null,
  bonusSections: [],
  bonusMarks: null,
  instruction: {
    _id: '608289ffb160b022e9442c83',
    title: 'BITSAT Instruction',
    instructions: [
      {
        _id: '60701540783231309cfb5fe9',
        position: 0,
        text: 'Instructions for BITSAT New Pattern',
      },
    ],
    createdAt: '2021-04-09T08:50:08.265Z',
    updatedAt: '2021-04-09T08:50:08.265Z',
    __v: 0,
  },
  totalTime: 180,
  basicAnalysis: {
    _id: '67370fa98e7e22fadb8ca3dc',
    isBonusAttempted: false,
    totalTimeTaken: 6780,
    totalMarkScored: 265,
    totalAttempted: 98,
    totalCorrect: 88,
    accuracy: 89.79591836734694,
    submittedAt: '2024-11-15T09:08:57.815Z',
  },
  packExpired: false,
  packVersion: 2,
  packSlug: 'bitsat-2025-full-test-series-for-class-12-july-batch',
  sections: [
    {
      _id: '667d30ed14e932e9dc100b89',
      sectionId: {
        _id: '671923ae6bc3007257f366ed',
        sectionType: 'normal',
        questions: Array(30).fill({ type: 'singleCorrect' }), // Physics - 30 questions
        title: 'Physics',
        subject: '607018ee404ae53194e73d90',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 3,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 30,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.124Z',
        updatedAt: '2024-06-27T09:29:16.124Z',
        __v: 0,
      },
      position: 0,
    },
    {
      _id: '667d30ed14e932e9dc100b8b',
      sectionId: {
        _id: '671923ae6bc3007257f366ef',
        sectionType: 'normal',
        questions: Array(30).fill({ type: 'singleCorrect' }), // Chemistry - 30 questions
        title: 'Chemistry',
        subject: '607018ee404ae53194e73d91',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 3,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 30,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.692Z',
        updatedAt: '2024-06-27T09:29:16.692Z',
        __v: 0,
      },
      position: 1,
    },
    {
      _id: '667d30ed14e932e9dc100b8d',
      sectionId: {
        _id: '671923af6bc3007257f366f1',
        sectionType: 'normal',
        questions: Array(40).fill({ type: 'singleCorrect' }), // Mathematics - 40 questions
        title: 'Mathematics',
        subject: '607018ee404ae53194e73d92',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 3,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 40,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:17.179Z',
        updatedAt: '2024-06-27T09:29:17.179Z',
        __v: 0,
      },
      position: 2,
    },
    {
      _id: '667d30ed14e932e9dc100b8e',
      sectionId: {
        _id: '671923af6bc3007257f366f2',
        sectionType: 'normal',
        questions: Array(10).fill({ type: 'singleCorrect' }), // English - 10 questions
        title: 'English',
        subject: '607018ee404ae53194e73d93',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 3,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 10,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:17.346Z',
        updatedAt: '2024-06-27T09:29:17.346Z',
        __v: 0,
      },
      position: 3,
    },
    {
      _id: '667d30ed14e932e9dc100b8f',
      sectionId: {
        _id: '671923af6bc3007257f366f3',
        sectionType: 'normal',
        questions: Array(20).fill({ type: 'singleCorrect' }), // Logical Reasoning - 20 questions
        title: 'Logical Reasoning',
        subject: '607018ee404ae53194e73d94',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 3,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 20,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:17.346Z',
        updatedAt: '2024-06-27T09:29:17.346Z',
        __v: 0,
      },
      position: 4,
    },
  ],
  subjects: [
    {
      _id: '667d30ed14e932e9dc100b90',
      totalMarks: 90,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b91',
      totalMarks: 90,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b92',
      totalMarks: 120,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 40,
      subjectId: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b93',
      totalMarks: 90,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 30,
      subjectId: {
        _id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
      },
    },
  ],
  chapters: [
    // Physics chapters (30)
    {
      _id: '60e2fadb66f9ce3f243b4799',
      title: 'Motion In One Dimension',
    },
    {
      _id: '60c9e849ea076dc381c0dfab',
      title: 'Mechanical Properties of Fluids',
    },
    {
      _id: '60c9e849ea076dc381c0dfaa',
      title: 'Work Power Energy',
    },
    // ... more physics chapters

    // Chemistry chapters (30)
    {
      _id: '60d2d1d2185d7a32fa3205ae',
      title: 'Chemical Bonding and Molecular Structure',
    },
    {
      _id: '60d2d1d2185d7a32fa3205c0',
      title: 'd and f Block Elements',
    },
    {
      _id: '60c9e849ea076dc381c0dfb1',
      title: 'Structure of Atom',
    },
    // ... more chemistry chapters

    // Mathematics chapters (40)
    {
      _id: '60c9e849ea076dc381c0dfb6',
      title: 'Binomial Theorem',
    },
    {
      _id: '60da9b5062f042332c53835f',
      title: 'Differential Equations',
    },
    {
      _id: '60e2faad66f9ce3f243b456c',
      title: 'Sets and Relations',
    },
    // ... more mathematics chapters

    // English chapters (10)
    {
      _id: '70e2faad66f9ce3f243b456d',
      title: 'Grammar',
    },
    {
      _id: '70e2faad66f9ce3f243b456e',
      title: 'Vocabulary',
    },
    {
      _id: '70e2faad66f9ce3f243b456f',
      title: 'Reading Comprehension',
    },

    // Logical Reasoning chapters (20)
    {
      _id: '70e2faad66f9ce3f243b4570',
      title: 'Logical Puzzles',
    },
    {
      _id: '70e2faad66f9ce3f243b4571',
      title: 'Analytical Reasoning',
    },
    {
      _id: '70e2faad66f9ce3f243b4572',
      title: 'Verbal Reasoning',
    },
    // ... more chapters
  ],
  description: 'Previous Year Paper as Mock Test',
};

export const overviewMockData = {
  success: true,
  message: 'Analysis overview sent successfully',
  data: {
    tabsToShow: [
      'Overview',
      'Performance Analysis',
      'Time Analysis',
      'Attempt Analysis',
      'Difficulty Analysis',
      'Subject Movement',
      'Question Journey',
      'Qs by Qs Analysis',
    ],

    tabIconsMapping: {
      Overview: 'CheckerboardIcon',
      'Performance Analysis': 'ChartLineIcon',
      'Score Potential': 'WarningDiamondIcon',
      'Attempt Analysis': 'CheckSquareOffsetIcon',
      'Time Analysis': 'ClockIcon',
      'Difficulty Analysis': 'SpeedometerIcon',
      'Subject Movement': 'NyTimesLogoIcon',
      'Question Journey': 'LineSegmentsIcon',
      'Qs by Qs Analysis': 'ListNumbersIcon',
    },

    percentileObject: {
      calculatedPercentile: {
        subjectWisePercentile: [
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
              title: 'Math',
              color: '#0086FF',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 120,
              markScored: 0,
              timeTaken: 6,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '85',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
              title: 'Phy',
              color: '#37B24D',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 90,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '80',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
              title: 'Chem',
              color: '#FF8C33',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 90,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '82',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
              title: 'ENG & LR',
              color: '#FF6B6B',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 90,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '78',
            },
          },
        ],
      },

      percentileData: {
        consolationText: "Below 90 isn't final. Revise, Analyze and Come Back Stronger",
        description: 'This percentile calculation is done on the basis of BITSAT 2025 January attempt data.',
      },

      isAvailable: true,
      isProjected: false,
    },

    subjectWiseData: {
      '607018ee404ae53194e73d92': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Math',
        color: '#0086FF',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 120,
        markScored: 72,
        timeTaken: 45,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d90': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Phy',
        color: '#37B24D',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 90,
        markScored: 63,
        timeTaken: 38,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d91': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Chem',
        color: '#FF8C33',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 90,
        markScored: 66,
        timeTaken: 32,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d93': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        title: 'ENG & LR',
        color: '#FF6B6B',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 90,
        markScored: 64,
        timeTaken: 25,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
    },

    overallData: {
      markScored: 265,
      totalScore: 390,
      userRank: 124,
      totalRanks: 18542,
    },

    overview: {
      markScored: 265,
      totalScore: 390,
      questionAttempted: 98,
      totalQuestions: 130,
      accuracy: '89.80',
      timeTaken: 113,
      positiveScore: 275,
      marksLost: 10,
    },

    paidFeatures: [],
    paymentLink: '#',
  },

  showCutoff: false,
};

export const performanceAnalysisMockData = {
  success: true,
  message: 'Performance Analysis Sent Successfully',
  performance: {
    testPerformance: {
      physics: {
        markScored: 63,
        totalScore: 90,
      },
      chemistry: {
        markScored: 66,
        totalScore: 90,
      },
      mathematics: {
        markScored: 72,
        totalScore: 120,
      },
      elr: {
        markScored: 64,
        totalScore: 90,
      },
      overall: {
        markScored: 265,
        totalScore: 390,
      },
    },
    testBreakdown: {
      physics: {
        correct: 23,
        incorrect: 3,
        unattempted: 4,
        notVisited: 0,
        totalQuestions: 30,
      },
      chemistry: {
        correct: 24,
        incorrect: 2,
        unattempted: 4,
        notVisited: 0,
        totalQuestions: 30,
      },
      mathematics: {
        correct: 26,
        incorrect: 4,
        unattempted: 10,
        notVisited: 0,
        totalQuestions: 40,
      },
      elr: {
        correct: 24,
        incorrect: 3,
        unattempted: 3,
        notVisited: 0,
        totalQuestions: 30,
      },
      overall: {
        correct: 97,
        incorrect: 12,
        unattempted: 21,
        notVisited: 0,
        totalQuestions: 130,
      },
    },
  },
  subjectMeta: {
    overall: {
      _id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    physics: {
      _id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    chemistry: {
      _id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    mathematics: {
      _id: '607018ee404ae53194e73d92',
      title: 'Mathematics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
      color: '#0086FF',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
    },
    elr: {
      _id: '607018ee404ae53194e73d93',
      title: 'English & Logical Reasoning',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
      color: '#FF6B6B',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
    },
  },
};

export const timeAnalysisMockData = {
  success: true,
  message: 'Time and accuracy analysis sent successfully',
  data: {
    timeAndAccuracy: {
      overall: {
        timeSpent: 113,
        totalQuestions: 130,
        attemptQuestions: 98,
        accuracy: '89.80',
      },
      physics: {
        timeSpent: 38,
        totalQuestions: 30,
        attemptQuestions: 26,
        accuracy: '88.46',
      },
      chemistry: {
        timeSpent: 32,
        totalQuestions: 30,
        attemptQuestions: 26,
        accuracy: '92.31',
      },
      mathematics: {
        timeSpent: 45,
        totalQuestions: 40,
        attemptQuestions: 30,
        accuracy: '86.67',
      },
      elr: {
        timeSpent: 25,
        totalQuestions: 30,
        attemptQuestions: 27,
        accuracy: '88.89',
      },
    },
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
      elr: {
        _id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        shortName: 'ELR',
        color: '#FF6B6B',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
      },
    },
    qualityOfTime: {
      overall: {
        timeSpentCorrect: 85,
        timeSpentIncorrect: 12,
        timeSpentUnattempted: 16,
      },
      physics: {
        timeSpentCorrect: 30,
        timeSpentIncorrect: 4,
        timeSpentUnattempted: 4,
      },
      chemistry: {
        timeSpentCorrect: 26,
        timeSpentIncorrect: 3,
        timeSpentUnattempted: 3,
      },
      mathematics: {
        timeSpentCorrect: 36,
        timeSpentIncorrect: 5,
        timeSpentUnattempted: 4,
      },
      elr: {
        timeSpentCorrect: 20,
        timeSpentIncorrect: 3,
        timeSpentUnattempted: 2,
      },
    },
    timeJourney: {
      '0-30M': {
        correct: 35,
        incorrect: 4,
        overall: 39,
      },
      '30-60M': {
        correct: 32,
        incorrect: 3,
        overall: 35,
      },
      '60-90M': {
        correct: 20,
        incorrect: 3,
        overall: 23,
      },
      '90-120M': {
        correct: 10,
        incorrect: 2,
        overall: 12,
      },
      '120-150M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
      '150-180M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
    },
  },
};

export const attemptAnalysisMockData = {
  success: true,
  message: 'Quality attempt analysis sent successfully',
  data: {
    subjectData: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
      elr: {
        _id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        shortName: 'ELR',
        color: '#FF6B6B',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
      },
    },
    overall: {
      perfect: 75,
      wasted: 2,
      overtime: 3,
      confused: 8,
    },
    physics: {
      perfect: 18,
      wasted: 1,
      overtime: 1,
      confused: 3,
    },
    chemistry: {
      perfect: 20,
      wasted: 0,
      overtime: 1,
      confused: 2,
    },
    mathematics: {
      perfect: 22,
      wasted: 1,
      overtime: 1,
      confused: 2,
    },
    elr: {
      perfect: 15,
      wasted: 0,
      overtime: 0,
      confused: 1,
    },
  },
};

export const difficultyAnalysisMockData = {
  data: {
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      mathematics: {
        _id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        shortName: 'Math',
        color: '#0086FF',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
      },
      elr: {
        _id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        shortName: 'ELR',
        color: '#FF6B6B',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40,58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
      },
    },
    overall: {
      easy: {
        correct: 42,
        incorrect: 3,
        notAttempted: 8,
        totalQuestions: 0,
      },
      moderate: {
        correct: 38,
        incorrect: 5,
        notAttempted: 9,
        totalQuestions: 0,
      },
      tough: {
        correct: 17,
        incorrect: 4,
        notAttempted: 4,
        totalQuestions: 0,
      },
    },
    physics: {
      easy: {
        correct: 10,
        incorrect: 1,
        notAttempted: 2,
      },
      moderate: {
        correct: 8,
        incorrect: 1,
        notAttempted: 1,
      },
      tough: {
        correct: 5,
        incorrect: 1,
        notAttempted: 1,
      },
    },
    chemistry: {
      easy: {
        correct: 11,
        incorrect: 1,
        notAttempted: 1,
      },
      moderate: {
        correct: 9,
        incorrect: 0,
        notAttempted: 2,
      },
      tough: {
        correct: 4,
        incorrect: 1,
        notAttempted: 1,
      },
    },
    mathematics: {
      easy: {
        correct: 12,
        incorrect: 1,
        notAttempted: 3,
      },
      moderate: {
        correct: 10,
        incorrect: 2,
        notAttempted: 4,
      },
      tough: {
        correct: 4,
        incorrect: 1,
        notAttempted: 3,
      },
    },
    elr: {
      easy: {
        correct: 9,
        incorrect: 0,
        notAttempted: 2,
      },
      moderate: {
        correct: 11,
        incorrect: 2,
        notAttempted: 2,
      },
      tough: {
        correct: 4,
        incorrect: 1,
        notAttempted: 0,
      },
    },
  },
};

export const subjectMovementTimelineMockData = {
  data: {
    success: true,
    message: 'Subject movement sent successfully!',
    journeyV2: [
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Started with Physics',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1231,
        relativeTimeStamp: 1731654480347,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: false,
        subjectName: 'Physics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 734,
        relativeTimeStamp: 1731655728560,
        questionAttemptedBeforeSwitch: 26,
        isOpenedAgain: true,
        subjectName: 'Chemistry',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched to Mathematics',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 789,
        relativeTimeStamp: 1731656293134,
        questionAttemptedBeforeSwitch: 26,
        isOpenedAgain: false,
        subjectName: 'Mathematics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        title: 'Switched to English & Logical Reasoning',
        color: '#FF6B6B',
        subjectId: '607018ee404ae53194e73d93',
        timeSpent: 353,
        relativeTimeStamp: 1731657097772,
        questionAttemptedBeforeSwitch: 30,
        isOpenedAgain: true,
        subjectName: 'English & Logical Reasoning',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched back to Physics',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 3319,
        relativeTimeStamp: 1731657455116,
        questionAttemptedBeforeSwitch: 27,
        isOpenedAgain: true,
        subjectName: 'Physics',
      },

      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
        title: 'Switched back to Mathematics',
        color: '#0086FF',
        subjectId: '607018ee404ae53194e73d92',
        timeSpent: 1124,
        relativeTimeStamp: 1731659124031,
        questionAttemptedBeforeSwitch: 41,
        isOpenedAgain: true,
        subjectName: 'Mathematics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Revisited Chemistry',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 642,
        relativeTimeStamp: 1731660248892,
        questionAttemptedBeforeSwitch: 52,
        isOpenedAgain: true,
        subjectName: 'Chemistry',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
        title: 'Returned to English & Logical Reasoning',
        color: '#FF6B6B',
        subjectId: '607018ee404ae53194e73d93',
        timeSpent: 488,
        relativeTimeStamp: 1731661135564,
        questionAttemptedBeforeSwitch: 58,
        isOpenedAgain: true,
        subjectName: 'English & Logical Reasoning',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Final Physics Revision',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1846,
        relativeTimeStamp: 1731662019038,
        questionAttemptedBeforeSwitch: 63,
        isOpenedAgain: true,
        subjectName: 'Physics',
      },
    ],
    isSingleSubjectTest: false,
  },
};

export const ErrorAnalysisMockData = {
  data: {
    errors: [
      {
        chapters: [
          {
            chapter: 'Electrostatics',
            topics: [
              {
                topic: 'Electric Field and Potential',
                answers: [
                  {
                    question: '667d30ec14e932e9dc1007ce',
                    status: 'answered',
                    questionNumber: 15,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Physics',
      },
      {
        chapters: [
          {
            chapter: 'Organic Chemistry',
            topics: [
              {
                topic: 'Reaction Mechanisms',
                answers: [
                  {
                    question: '667d30ec14e932e9dc100931',
                    status: 'answered',
                    questionNumber: 42,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Chemistry',
      },
      {
        chapters: [
          {
            chapter: 'Calculus',
            topics: [
              {
                topic: 'Integration',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100aad',
                    status: 'answered',
                    questionNumber: 73,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Mathematics',
      },
      {
        chapters: [
          {
            chapter: 'Reading Comprehension',
            topics: [
              {
                topic: 'Inference Questions',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100b57',
                    status: 'answered',
                    questionNumber: 115,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'English & Logical Reasoning',
      },
    ],
    scoreImprovement: [
      {
        subjectMeta: {
          _id: 'overall',
          title: 'Overall',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
          color: '#364FC7',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 50,
            improvedScoreByErrorReduction: 277,
            actualScore: 265,
            maxScore: 390,
            moreCorrectCouldBe: 4,
          },
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 289,
            actualScore: 265,
            maxScore: 390,
            moreCorrectCouldBe: 8,
          },
        ],
        actual: {
          actualScore: 265,
          maxScore: 390,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d90',
          title: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          shortName: 'Phy',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 69,
            actualScore: 63,
            maxScore: 90,
            moreCorrectCouldBe: 2,
          },
        ],
        actual: {
          actualScore: 63,
          maxScore: 90,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d91',
          title: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          shortName: 'Chem',
          color: '#FF8C33',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 72,
            actualScore: 66,
            maxScore: 90,
            moreCorrectCouldBe: 2,
          },
        ],
        actual: {
          actualScore: 66,
          maxScore: 90,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d92',
          title: 'Mathematics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
          shortName: 'Math',
          color: '#0086FF',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 84,
            actualScore: 72,
            maxScore: 120,
            moreCorrectCouldBe: 4,
          },
        ],
        actual: {
          actualScore: 72,
          maxScore: 120,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d93',
          title: 'English & Logical Reasoning',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
          shortName: 'ELR',
          color: '#FF6B6B',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 73,
            actualScore: 64,
            maxScore: 90,
            moreCorrectCouldBe: 3,
          },
        ],
        actual: {
          actualScore: 64,
          maxScore: 90,
        },
      },
    ],
  },
};

export const QuestionJourneyMockData = {
  data: {
    success: true,
    message: 'Question journey sent successfully!',
    data: [
      // Physics Section (Questions 1-30)
      Array(30)
        .fill()
        .map((_, i) => ({
          questionNumber: i + 1,
          questionId: `physics_q${i + 1}`,
          isCorrect: Math.random() > 0.3, // ~70% correct
          timeVisited: Math.floor(Math.random() * 2) + 1,
          isSkipped: Math.random() > 0.8, // ~20% skipped
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731654480352 + i * 10000,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions:
            Math.random() > 0.2
              ? [
                  {
                    optionId: 'opt_' + i,
                    optionNumber: Math.floor(Math.random() * 4) + 1,
                    optionValue: `Option ${Math.floor(Math.random() * 4) + 1}`,
                  },
                ]
              : [],
        })),

      // Chemistry Section (Questions 31-60)
      Array(30)
        .fill()
        .map((_, i) => ({
          questionNumber: i + 31,
          questionId: `chemistry_q${i + 1}`,
          isCorrect: Math.random() > 0.25, // ~75% correct
          timeVisited: Math.floor(Math.random() * 2) + 1,
          isSkipped: Math.random() > 0.85, // ~15% skipped
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731656293134 + i * 8000,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions:
            Math.random() > 0.15
              ? [
                  {
                    optionId: 'chem_opt_' + i,
                    optionNumber: Math.floor(Math.random() * 4) + 1,
                    optionValue: `Chem Option ${Math.floor(Math.random() * 4) + 1}`,
                  },
                ]
              : [],
        })),

      // Mathematics Section (Questions 61-100)
      Array(40)
        .fill()
        .map((_, i) => ({
          questionNumber: i + 61,
          questionId: `maths_q${i + 1}`,
          isCorrect: Math.random() > 0.35, // ~65% correct
          timeVisited: Math.floor(Math.random() * 2) + 1,
          isSkipped: Math.random() > 0.7, // ~30% skipped
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731657455116 + i * 6000,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions:
            Math.random() > 0.25
              ? [
                  {
                    optionId: 'math_opt_' + i,
                    optionNumber: Math.floor(Math.random() * 4) + 1,
                    optionValue: `Math Option ${Math.floor(Math.random() * 4) + 1}`,
                  },
                ]
              : [],
        })),

      // English & Logical Reasoning Section (Questions 101-130)
      Array(30)
        .fill()
        .map((_, i) => ({
          questionNumber: i + 101,
          questionId: `elr_q${i + 1}`,
          isCorrect: Math.random() > 0.2, // ~80% correct
          timeVisited: Math.floor(Math.random() * 2) + 1,
          isSkipped: Math.random() > 0.9, // ~10% skipped
          isMarkedReview: false,
          isUnmarkedReview: false,
          relativeTimeStamp: 1731660102311 + i * 5000,
          inputValue: null,
          questionType: 'singleCorrect',
          selectedOptions:
            Math.random() > 0.1
              ? [
                  {
                    optionId: 'elr_opt_' + i,
                    optionNumber: Math.floor(Math.random() * 4) + 1,
                    optionValue: `ELR Option ${Math.floor(Math.random() * 4) + 1}`,
                  },
                ]
              : [],
        })),
    ],
  },
};

export const AllQuestionsAnalysisMockData = {
  data: {
    data: {
      allQuestionsAnalysis: [
        {
          subject: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array(30)
                .fill()
                .map((_, i) => {
                  const isCorrect = Math.random() > 0.2;
                  const isPainful = !isCorrect;
                  const status = isPainful ? 'answered' : Math.random() > 0.1 ? 'answered' : 'notAnswered';
                  return {
                    question: `physics_q${i + 1}`,
                    status,
                    isCorrect,
                    isPainful,
                    isImportant: Math.random() > 0.7,
                    isMarkedForReview: false,
                    timesVisited: Math.floor(Math.random() * 2) + 1,
                    questionNumber: i + 1,
                  };
                }),
            },
          ],
        },
        {
          subject: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          color: '#FF8C33',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array(30)
                .fill()
                .map((_, i) => {
                  const isCorrect = Math.random() > 0.2;
                  const isPainful = !isCorrect;
                  const status = isPainful ? 'answered' : Math.random() > 0.1 ? 'answered' : 'notAnswered';
                  return {
                    question: `chemistry_q${i + 1}`,
                    status,
                    isCorrect,
                    isPainful,
                    isImportant: Math.random() > 0.7,
                    isMarkedForReview: false,
                    timesVisited: Math.floor(Math.random() * 2) + 1,
                    questionNumber: i + 31,
                  };
                }),
            },
          ],
        },
        {
          subject: 'Mathematics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
          color: '#0086FF',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array(40)
                .fill()
                .map((_, i) => {
                  const isCorrect = Math.random() > 0.2;
                  const isPainful = !isCorrect;
                  const status = isPainful ? 'answered' : Math.random() > 0.1 ? 'answered' : 'notAnswered';
                  return {
                    question: `maths_q${i + 1}`,
                    status,
                    isCorrect,
                    isPainful,
                    isImportant: Math.random() > 0.7,
                    isMarkedForReview: false,
                    timesVisited: Math.floor(Math.random() * 2) + 1,
                    questionNumber: i + 61,
                  };
                }),
            },
          ],
        },
        {
          subject: 'English & Logical Reasoning',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
          color: '#FF6B6B',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array(30)
                .fill()
                .map((_, i) => {
                  const isCorrect = Math.random() > 0.2;
                  const isPainful = !isCorrect;
                  const status = isPainful ? 'answered' : Math.random() > 0.1 ? 'answered' : 'notAnswered';
                  return {
                    question: `elr_q${i + 1}`,
                    status,
                    isCorrect,
                    isPainful,
                    isImportant: Math.random() > 0.7,
                    isMarkedForReview: false,
                    timesVisited: Math.floor(Math.random() * 2) + 1,
                    questionNumber: i + 101,
                  };
                }),
            },
          ],
        },
      ],
      allQuestionsDetailedAnalysis: [
        // Sample Physics questions analysis (30 entries)
        ...Array(30)
          .fill()
          .map((_, i) => ({
            _id: `physics_q${i + 1}`,
            chapter: ['Motion', 'Electrostatics', 'Optics', 'Thermodynamics'][i % 4],
            topics: ['Kinematics', 'Electric Field', 'Refraction', 'Laws'][i % 4],
            concept: ['Velocity', 'Potential', "Snell's Law", 'First Law'][i % 4],
            level: (i % 3) + 1,
            approximateTimeRequired: [60, 90, 120][i % 3],
            attemptOverview: ['perfect', 'confused', 'wasted', 'overtime'][i % 4],
            isCorrect: Math.random() > 0.3,
            timeTaken: [30, 45, 60, 90][i % 4],
            status: Math.random() > 0.2 ? 'answered' : 'notAnswered',
            subject: 'Physics',
          })),

        // Sample Chemistry questions analysis (30 entries)
        ...Array(30)
          .fill()
          .map((_, i) => ({
            _id: `chemistry_q${i + 1}`,
            chapter: ['Organic', 'Inorganic', 'Physical', 'Analytical'][i % 4],
            topics: ['Hydrocarbons', 'Periodic Table', 'Thermodynamics', 'Titration'][i % 4],
            concept: ['Nomenclature', 'Trends', 'Enthalpy', 'End Point'][i % 4],
            level: (i % 3) + 1,
            approximateTimeRequired: [60, 90, 120][i % 3],
            attemptOverview: ['perfect', 'confused', 'wasted', 'overtime'][i % 4],
            isCorrect: Math.random() > 0.25,
            timeTaken: [25, 40, 55, 75][i % 4],
            status: Math.random() > 0.15 ? 'answered' : 'notAnswered',
            subject: 'Chemistry',
          })),

        // Sample Mathematics questions analysis (40 entries)
        ...Array(40)
          .fill()
          .map((_, i) => ({
            _id: `maths_q${i + 1}`,
            chapter: ['Algebra', 'Calculus', 'Geometry', 'Trigonometry'][i % 4],
            topics: ['Equations', 'Differentiation', 'Circles', 'Identities'][i % 4],
            concept: ['Quadratic', 'Chain Rule', 'Equation', 'Sin^2 + Cos^2'][i % 4],
            level: (i % 3) + 1,
            approximateTimeRequired: [90, 120, 150][i % 3],
            attemptOverview: ['perfect', 'confused', 'wasted', 'overtime'][i % 4],
            isCorrect: Math.random() > 0.35,
            timeTaken: [40, 60, 80, 100][i % 4],
            status: Math.random() > 0.3 ? 'answered' : 'notAnswered',
            subject: 'Mathematics',
          })),

        // Sample ELR questions analysis (30 entries)
        ...Array(30)
          .fill()
          .map((_, i) => ({
            _id: `elr_q${i + 1}`,
            chapter: i < 10 ? 'English' : 'Logical Reasoning',
            topics:
              i < 10 ? ['Grammar', 'Vocabulary', 'Comprehension'][i % 3] : ['Puzzles', 'Series', 'Analogy'][i % 3],
            concept:
              i < 10 ? ['Tenses', 'Synonyms', 'Main Idea'][i % 3] : ['Pattern', 'Sequence', 'Relationship'][i % 3],
            level: (i % 3) + 1,
            approximateTimeRequired: [45, 60, 75][i % 3],
            attemptOverview: ['perfect', 'confused', 'wasted', 'overtime'][i % 4],
            isCorrect: Math.random() > 0.2,
            timeTaken: [20, 30, 40, 50][i % 4],
            status: Math.random() > 0.1 ? 'answered' : 'notAnswered',
            subject: 'English & Logical Reasoning',
          })),
      ],
    },
  },
};

export const ComparativeAnalysisMockData = {
  comparativeData: {
    _id: '67285c3e6b7f0e07ff641ea9',
    test_id: '671923ae6bc3007257f366ec',
    __v: 0,
    accuracy: [
      {
        values: {
          topper: '100',
          average: '68.5',
          top_10_percent: '88.2',
          top_25_percent: '80.5',
        },
        _id: '6757c33573e94bc3676580d7',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '100',
          average: '71.3',
          top_10_percent: '90.1',
          top_25_percent: '83.7',
        },
        _id: '6757c33573e94bc3676580d8',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '100',
          average: '62.8',
          top_10_percent: '85.4',
          top_25_percent: '76.9',
        },
        _id: '6757c33573e94bc3676580d9',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '100',
          average: '74.2',
          top_10_percent: '92.6',
          top_25_percent: '86.3',
        },
        _id: '6757c33573e94bc3676580da',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
      },
      {
        values: {
          topper: '100',
          average: '69.2',
          top_10_percent: '89.1',
          top_25_percent: '81.8',
        },
        _id: '6757c33573e94bc3676580db',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    attempt_analysis: [
      {
        _id: '6757c33573e94bc3676580af',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            title: 'Perfect',
            values: { topper: '27', average: '18', top_10_percent: '25', top_25_percent: '22' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '3', top_10_percent: '1', top_25_percent: '2' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
        ],
        topper_attempt_percent: '93.3',
        average_attempt_percent: '83.3',
        top_10_percent_attempt_percent: '93.3',
        top_25_percent_attempt_percent: '86.7',
      },

      {
        _id: '6757c33573e94bc3676580b4',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            title: 'Perfect',
            values: { topper: '27', average: '20', top_10_percent: '26', top_25_percent: '24' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '1', top_10_percent: '0', top_25_percent: '0' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '2', top_10_percent: '1', top_25_percent: '1' },
          },
        ],
        topper_attempt_percent: '93.3',
        average_attempt_percent: '83.3',
        top_10_percent_attempt_percent: '93.3',
        top_25_percent_attempt_percent: '86.7',
      },

      {
        _id: '6757c33573e94bc3676580b9',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            title: 'Perfect',
            values: { topper: '36', average: '24', top_10_percent: '32', top_25_percent: '28' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '3', top_10_percent: '1', top_25_percent: '2' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '4', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '3', top_10_percent: '2', top_25_percent: '2' },
          },
        ],
        topper_attempt_percent: '95.0',
        average_attempt_percent: '85.0',
        top_10_percent_attempt_percent: '92.5',
        top_25_percent_attempt_percent: '87.5',
      },

      {
        _id: '6757c33573e94bc3676580be',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        values: [
          {
            title: 'Perfect',
            values: { topper: '26', average: '22', top_10_percent: '26', top_25_percent: '24' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '1', top_10_percent: '0', top_25_percent: '0' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '1', top_10_percent: '0', top_25_percent: '1' },
          },
          {
            title: 'Confused',
            values: { topper: '1', average: '1', top_10_percent: '1', top_25_percent: '1' },
          },
        ],
        topper_attempt_percent: '93.3',
        average_attempt_percent: '83.3',
        top_10_percent_attempt_percent: '90.0',
        top_25_percent_attempt_percent: '86.7',
      },

      {
        _id: '6757c33573e94bc3676580c3',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            title: 'Perfect',
            values: { topper: '116', average: '84', top_10_percent: '109', top_25_percent: '98' },
          },
          {
            title: 'Wasted',
            values: { topper: '3', average: '7', top_10_percent: '2', top_25_percent: '4' },
          },
          {
            title: 'Overtime',
            values: { topper: '3', average: '10', top_10_percent: '4', top_25_percent: '7' },
          },
          {
            title: 'Confused',
            values: { topper: '3', average: '8', top_10_percent: '5', top_25_percent: '6' },
          },
        ],
        topper_attempt_percent: '93.8',
        average_attempt_percent: '83.8',
        top_10_percent_attempt_percent: '92.3',
        top_25_percent_attempt_percent: '88.5',
      },
    ],
    createdAt: '2024-11-04T05:31:42.575Z',
    difficulty_analysis: [
      {
        _id: '6757c33573e94bc36765809f',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper_correct: '12',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '2',
              average_unattempted: '2',
              top_10_percent_correct: '10',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '9',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '0',
            },
            _id: '6757c33573e94bc3676580a0',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '10',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '6',
              average_incorrect: '2',
              average_unattempted: '4',
              top_10_percent_correct: '9',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '8',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a1',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '8',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '4',
              average_incorrect: '2',
              average_unattempted: '4',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '6',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a2',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a3',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper_correct: '12',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '9',
              average_incorrect: '1',
              average_unattempted: '2',
              top_10_percent_correct: '11',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '10',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a4',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '10',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '7',
              average_incorrect: '1',
              average_unattempted: '4',
              top_10_percent_correct: '9',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '8',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a5',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '8',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '5',
              average_incorrect: '2',
              average_unattempted: '3',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '6',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a6',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a7',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            values: {
              topper_correct: '16',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '10',
              average_incorrect: '2',
              average_unattempted: '4',
              top_10_percent_correct: '14',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '12',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a8',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '14',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '3',
              average_unattempted: '7',
              top_10_percent_correct: '12',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '3',
              top_25_percent_correct: '10',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '5',
            },
            _id: '6757c33573e94bc3676580a9',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '10',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '6',
              average_incorrect: '2',
              average_unattempted: '6',
              top_10_percent_correct: '9',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '3',
              top_25_percent_correct: '8',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '4',
            },
            _id: '6757c33573e94bc3676580aa',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580ab',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        values: [
          {
            values: {
              topper_correct: '12',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '10',
              average_incorrect: '1',
              average_unattempted: '1',
              top_10_percent_correct: '11',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '10',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580ac',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '10',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '1',
              average_unattempted: '3',
              top_10_percent_correct: '9',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '8',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580ad',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '8',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '6',
              average_incorrect: '1',
              average_unattempted: '3',
              top_10_percent_correct: '7',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '6',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580ae',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580af',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper_correct: '52',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '37',
              average_incorrect: '6',
              average_unattempted: '9',
              top_10_percent_correct: '46',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '2',
              top_25_percent_correct: '41',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '5',
            },
            _id: '6757c33573e94bc3676580b0',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '44',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '29',
              average_incorrect: '7',
              average_unattempted: '18',
              top_10_percent_correct: '39',
              top_10_percent_incorrect: '1',
              top_10_percent_unattempted: '6',
              top_25_percent_correct: '34',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '11',
            },
            _id: '6757c33573e94bc3676580b1',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '34',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '21',
              average_incorrect: '7',
              average_unattempted: '16',
              top_10_percent_correct: '29',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '6',
              top_25_percent_correct: '26',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '10',
            },
            _id: '6757c33573e94bc3676580b2',
            title: 'Tough',
          },
        ],
      },
    ],
    hour_wise_breakdown: [
      {
        values: {
          topper: {
            correct: 85,
            incorrect: 2,
            total: 87,
          },
          top_10_percent: {
            correct: 68,
            incorrect: 5,
            total: 73,
          },
          top_25_percent: {
            correct: 59,
            incorrect: 7,
            total: 66,
          },
          average: {
            correct: 42,
            incorrect: 12,
            total: 54,
          },
        },
        _id: '6757c33573e94bc36765809c',
        title: '1st Hour',
      },
      {
        values: {
          topper: {
            correct: 37,
            incorrect: 1,
            total: 38,
          },
          top_10_percent: {
            correct: 32,
            incorrect: 3,
            total: 35,
          },
          top_25_percent: {
            correct: 28,
            incorrect: 4,
            total: 32,
          },
          average: {
            correct: 22,
            incorrect: 8,
            total: 30,
          },
        },
        _id: '6757c33573e94bc36765809d',
        title: '2nd Hour',
      },
      {
        values: {
          topper: {
            correct: 8,
            incorrect: 0,
            total: 8,
          },
          top_10_percent: {
            correct: 10,
            incorrect: 1,
            total: 11,
          },
          top_25_percent: {
            correct: 13,
            incorrect: 2,
            total: 15,
          },
          average: {
            correct: 25,
            incorrect: 15,
            total: 40,
          },
        },
        _id: '6757c33573e94bc36765809e',
        title: '3rd Hour',
      },
    ],
    scores: [
      {
        values: {
          topper: '90',
          average: '48',
          top_10_percent: '78',
          top_25_percent: '66',
        },
        _id: '6757c33573e94bc3676580dc',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '90',
          average: '51',
          top_10_percent: '81',
          top_25_percent: '72',
        },
        _id: '6757c33573e94bc3676580dd',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '120',
          average: '66',
          top_10_percent: '102',
          top_25_percent: '87',
        },
        _id: '6757c33573e94bc3676580de',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '90',
          average: '63',
          top_10_percent: '81',
          top_25_percent: '72',
        },
        _id: '6757c33573e94bc3676580df',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
      },
      {
        values: {
          topper: '390',
          average: '228',
          top_10_percent: '342',
          top_25_percent: '297',
        },
        _id: '6757c33573e94bc3676580e0',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    test_breakdown: [
      {
        _id: '6757c33573e94bc3676580c8',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper: '30',
              average: '20',
              top_10_percent: '26',
              top_25_percent: '24',
            },
            _id: '6757c33573e94bc3676580c9',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '4',
              top_10_percent: '1',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580ca',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '5',
              top_10_percent: '2',
              top_25_percent: '3',
            },
            _id: '6757c33573e94bc3676580cb',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '1',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580cc',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580cd',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper: '30',
              average: '22',
              top_10_percent: '27',
              top_25_percent: '25',
            },
            _id: '6757c33573e94bc3676580ce',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '3',
              top_10_percent: '1',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580cf',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '4',
              top_10_percent: '1',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580d0',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '1',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580d1',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d2',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        values: [
          {
            values: {
              topper: '40',
              average: '24',
              top_10_percent: '35',
              top_25_percent: '30',
            },
            _id: '6757c33573e94bc3676580d3',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '7',
              top_10_percent: '2',
              top_25_percent: '4',
            },
            _id: '6757c33573e94bc3676580d4',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '8',
              top_10_percent: '2',
              top_25_percent: '5',
            },
            _id: '6757c33573e94bc3676580d5',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '1',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580d6',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d7',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        values: [
          {
            values: {
              topper: '30',
              average: '24',
              top_10_percent: '27',
              top_25_percent: '26',
            },
            _id: '6757c33573e94bc3676580d8',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '3',
              top_10_percent: '1',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580d9',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '2',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580da',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '1',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580db',
            title: 'Not Visited',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580dc',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper: '130',
              average: '90',
              top_10_percent: '115',
              top_25_percent: '105',
            },
            _id: '6757c33573e94bc3676580dd',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '17',
              top_10_percent: '5',
              top_25_percent: '10',
            },
            _id: '6757c33573e94bc3676580de',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '19',
              top_10_percent: '6',
              top_25_percent: '11',
            },
            _id: '6757c33573e94bc3676580df',
            title: 'Unattempted',
          },
          {
            values: {
              topper: '0',
              average: '4',
              top_10_percent: '4',
              top_25_percent: '4',
            },
            _id: '6757c33573e94bc3676580e0',
            title: 'Not Visited',
          },
        ],
      },
    ],
    test_name: 'BITSAT 2024 Full Test',
    time_spent: [
      {
        values: {
          topper: '2100',
          average: '1850',
          top_10_percent: '1980',
          top_25_percent: '1920',
        },
        _id: '6757c33573e94bc3676580e1',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '1800',
          average: '1620',
          top_10_percent: '1720',
          top_25_percent: '1680',
        },
        _id: '6757c33573e94bc3676580e2',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '3000',
          average: '2520',
          top_10_percent: '2820',
          top_25_percent: '2700',
        },
        _id: '6757c33573e94bc3676580e3',
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
      },
      {
        values: {
          topper: '1500',
          average: '1380',
          top_10_percent: '1440',
          top_25_percent: '1410',
        },
        _id: '6757c33573e94bc3676580e4',
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
      },
      {
        values: {
          topper: '8400',
          average: '7370',
          top_10_percent: '7960',
          top_25_percent: '7710',
        },
        _id: '6757c33573e94bc3676580e5',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    updatedAt: '2024-12-10T04:27:33.405Z',
  },
  userData: {
    accuracy: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        accuracy: 88.46,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        accuracy: 92.31,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        accuracy: 86.67,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        accuracy: 88.89,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        accuracy: 89.8,
      },
    ],
    attempt_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        perfect_attempts: 18,
        overtime_attempts: 1,
        confused_attempts: 3,
        wasted_attempts: 1,
        attempt_percentage: '86.67',
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        perfect_attempts: 20,
        overtime_attempts: 1,
        confused_attempts: 2,
        wasted_attempts: 0,
        attempt_percentage: '86.67',
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        perfect_attempts: 22,
        overtime_attempts: 1,
        confused_attempts: 2,
        wasted_attempts: 1,
        attempt_percentage: '75.00',
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        perfect_attempts: 15,
        overtime_attempts: 0,
        confused_attempts: 1,
        wasted_attempts: 0,
        attempt_percentage: '90.00',
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        perfect_attempts: 75,
        overtime_attempts: 3,
        confused_attempts: 8,
        wasted_attempts: 2,
        attempt_percentage: '84.62',
      },
    ],
    difficulty_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        easyCorrect: 10,
        easyIncorrect: 1,
        easyUnattempted: 2,
        moderateCorrect: 8,
        moderateIncorrect: 1,
        moderateUnattempted: 1,
        toughCorrect: 5,
        toughIncorrect: 1,
        toughUnattempted: 1,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        easyCorrect: 11,
        easyIncorrect: 1,
        easyUnattempted: 1,
        moderateCorrect: 9,
        moderateIncorrect: 0,
        moderateUnattempted: 2,
        toughCorrect: 4,
        toughIncorrect: 1,
        toughUnattempted: 1,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        easyCorrect: 12,
        easyIncorrect: 1,
        easyUnattempted: 3,
        moderateCorrect: 10,
        moderateIncorrect: 2,
        moderateUnattempted: 4,
        toughCorrect: 4,
        toughIncorrect: 1,
        toughUnattempted: 3,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        easyCorrect: 9,
        easyIncorrect: 0,
        easyUnattempted: 2,
        moderateCorrect: 11,
        moderateIncorrect: 2,
        moderateUnattempted: 2,
        toughCorrect: 4,
        toughIncorrect: 1,
        toughUnattempted: 0,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        easyCorrect: 42,
        easyIncorrect: 3,
        easyUnattempted: 8,
        moderateCorrect: 38,
        moderateIncorrect: 5,
        moderateUnattempted: 9,
        toughCorrect: 17,
        toughIncorrect: 4,
        toughUnattempted: 4,
      },
    ],
    hour_wise_breakdown: [
      {
        title: '1st Hour',
        values: {
          correct: 52,
          incorrect: 6,
          total: 58,
        },
      },
      {
        title: '2nd Hour',
        values: {
          correct: 35,
          incorrect: 4,
          total: 39,
        },
      },
      {
        title: '3rd Hour',
        values: {
          correct: 10,
          incorrect: 2,
          total: 12,
        },
      },
    ],
    scores: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        score: 63,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        score: 66,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        score: 72,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        score: 64,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        score: 265,
      },
    ],
    test_breakdown: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        correct: 23,
        incorrect: 3,
        unattempted: 4,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        correct: 24,
        incorrect: 2,
        unattempted: 4,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        correct: 26,
        incorrect: 4,
        unattempted: 10,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        correct: 24,
        incorrect: 3,
        unattempted: 3,
        notVisited: 0,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        correct: 97,
        incorrect: 12,
        unattempted: 21,
        notVisited: 0,
      },
    ],
    time_spent: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        time_spent: 2280, // 38 minutes in seconds
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        time_spent: 1920, // 32 minutes in seconds
      },
      {
        subject_id: '607018ee404ae53194e73d92',
        title: 'Mathematics',
        time_spent: 2700, // 45 minutes in seconds
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'English & Logical Reasoning',
        time_spent: 1500, // 25 minutes in seconds
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        time_spent: 8400, // 140 minutes in seconds (2 hours 20 minutes)
      },
    ],
  },
  subjectMeta: {
    Physics: {
      id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    Chemistry: {
      id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    Mathematics: {
      id: '607018ee404ae53194e73d92',
      title: 'Mathematics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/maths.svg',
      color: '#0086FF',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Maths, #0086FF)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Maths, #0086FF)',
    },
    'English & Logical Reasoning': {
      id: '607018ee404ae53194e73d93',
      title: 'English & Logical Reasoning',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/english.svg',
      color: '#FF6B6B',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--ELR, #FF6B6B)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--ELR, #FF6B6B)',
    },
    Overall: {
      id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
  },
  difficultyWiseQuestions: {
    Physics: {
      easy: 12,
      moderate: 10,
      tough: 8,
    },
    Chemistry: {
      easy: 12,
      moderate: 10,
      tough: 8,
    },
    Mathematics: {
      easy: 16,
      moderate: 14,
      tough: 10,
    },
    'English & Logical Reasoning': {
      easy: 12,
      moderate: 10,
      tough: 8,
    },
  },
  totalQuestions: {
    total: 130,
    '607018ee404ae53194e73d90': 30,
    '607018ee404ae53194e73d91': 30,
    '607018ee404ae53194e73d92': 40,
    '607018ee404ae53194e73d93': 30,
  },
};

export const PercentileMockData = {
  percentileData: {
    _id: '673c75ef2621a3331bdc7b55',
    title: 'BITSAT 2024 Full Test',
    description: 'This percentile calculation is done on the basis of BITSAT 2024 data',
    consolationText:
      'Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.',
    data: Array.from({ length: 391 }, (_, i) => {
      const score = 390 - i;
      let percentile;

      // Generate realistic percentile distribution
      if (score >= 370) percentile = 99.9 - (390 - score) * 0.0125;
      else if (score >= 350) percentile = 99.8 - (370 - score) * 0.02;
      else if (score >= 330) percentile = 99.4 - (350 - score) * 0.03;
      else if (score >= 300) percentile = 98.5 - (330 - score) * 0.04;
      else if (score >= 270) percentile = 96.5 - (300 - score) * 0.05;
      else if (score >= 240) percentile = 93.0 - (270 - score) * 0.06;
      else if (score >= 210) percentile = 87.0 - (240 - score) * 0.07;
      else if (score >= 180) percentile = 78.0 - (210 - score) * 0.08;
      else if (score >= 150) percentile = 66.0 - (180 - score) * 0.09;
      else if (score >= 120) percentile = 51.0 - (150 - score) * 0.1;
      else if (score >= 90) percentile = 33.0 - (120 - score) * 0.11;
      else if (score >= 60) percentile = 18.0 - (90 - score) * 0.12;
      else percentile = 6.0 - (60 - score) * 0.15;

      // Ensure percentile is between 0 and 100
      percentile = Math.max(0, Math.min(100, percentile));

      return {
        _id: `673c75ef2621a3331bdc7b${(1000 + i).toString(16)}`,
        percentile: parseFloat(percentile.toFixed(4)),
        score: score,
      };
    }).filter((item) => item.percentile >= 0), // Filter out negative percentiles
    createdAt: '2024-11-19T16:56:39.111Z',
    updatedAt: '2024-11-19T16:56:39.111Z',
    __v: 0,
  },
  isAvailable: true,
  version: 1,
};
